import React from 'react';
import styled from '@emotion/styled';
import Results, { ResultItem } from '../Symbols/Results';

const formatCurrency = amount => {
	return amount.toLocaleString('cs') + ' Kč';
};

const ResultNumber = styled('span')`
	font-style: italic;
	text-align: right;
`;

export default function StyledResult({ uec }) {
	return (
		<Results data-cy="result">
			<ResultItem name="Trvání podpory:">
				<ResultNumber>{uec.duration} měsíců</ResultNumber>
			</ResultItem>
			{[
				{ name: 'Podpora v 1. a 2. měsíci:', value: uec.aid.firstPhase },
				{ name: 'Podpora v 3. a 4. měsíci:', value: uec.aid.secondPhase },
				{
					name: 'Podpora ' + (uec.duration > 5 ? 'od 5. měsíce:' : 'v 5. měsíci:'),
					value: uec.aid.lastPhase,
				},
			].map(({ name, value }) => {
				return (
					<ResultItem key={name} name={name}>
						<ResultNumber>{formatCurrency(value)}</ResultNumber>
					</ResultItem>
				);
			})}
		</Results>
	);
}
